import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./initialExplanation.sass";
import DOMPurify from "dompurify";

import usePage from "../../hooks/usePage";
import btn from "../../assets/images/initialExplanation/btn.png";

export default function Home() {
  const { t } = useTranslation();
  const userName = useSelector((state) => state.user.userName);
  usePage({});

  return (
    <article className="initial-explanation">
      <div className="wrapper">
        <div className="title">
          <div className="bg">
            <div className="txt">
              <p>{t("initialExplanation.title")}</p>
              <p>{t("initialExplanation.subTitle")}</p>
            </div>
          </div>
        </div>
        <div className="information">
          <div className="txt">
            {t("initialExplanation.hello", { name: userName })}
            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(t("initialExplanation.content")),
              }}
            ></p>
          </div>
        </div>
        <Link to="/bearExplanation">
          <figure className="btn">
            <img src={btn} alt="" />
          </figure>
        </Link>
        <p className="remind">{t("initialExplanation.remind")}</p>
      </div>
    </article>
  );
}
